import Cookies from "js-cookie";

const insertAbout = () => {
  const COOKIE_KEY = "hide_insert_about";
  const insertAbout = document.getElementById("js-insert-about");

  if (!insertAbout) {
    return;
  }
  Cookies.get(COOKIE_KEY) ? insertAbout.remove() : Cookies.set(COOKIE_KEY, "1", { expires: 30 });
};

export { insertAbout };
